var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg611(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reverse",
    fillRule: "evenodd",
    strokeWidth: 1.8,
    transform: "translate(1.597400, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "base",
    stroke: "#687577",
    fill: "#FFFFFF",
    d: "M9.72129802,34.4929263 C8.855553,34.4929263 7.92069966,34.3712998 7.46272811,34.1180263 C4.73827874,32.6087516 1.38497804,28.619263 0.0361624364,23.1056419 C0.0239009729,23.0552737 0.0170995324,23.00372 0.0158769098,22.951881 C-0.0133480015,21.7459816 0.00315547781,20.873173 0.022409537,19.8628434 C0.0361624364,19.1334298 0.0516344482,18.3300727 0.0516344482,17.2737877 C0.0516344482,9.15383425 2.63958629,3.81366914 5.06147188,1.52591546 C6.18405229,0.465138565 7.34376553,-0.0607579921 8.42818165,0.00558375493 C12.0434751,0.00558375493 18.4444183,3.69135154 20.5644277,9.69286094 C20.606411,9.8121915 20.5756897,9.93850616 20.5939965,10.0649967 C20.9550797,12.5599011 20.4083306,14.8559881 20.4051456,17.2737877 C20.4051456,18.0940757 20.4051456,19.0342762 20.4051456,19.8628434 C20.4051456,21.9531628 20.3265026,23.7320876 19.5284906,25.5101847 C17.8595762,29.2267046 14.4302908,32.9103992 11.3743965,34.2700595 C10.8406603,34.4413224 10.2810779,34.5167639 9.72129802,34.4929263 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.400000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hookstyle",
    transform: "scale(-1, 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hook",
    fill: "none",
    transform: "translate(-8.000000, -9.000000)",
    d: "M3.58716581,4.86252597 C3.06706263,4.62380711 2.85229747,4.03585383 3.10747439,3.54929557 C3.36265132,3.06273731 3.99114002,2.86182379 4.5112432,3.10054265 C5.46056455,3.53626565 6.39450266,4.14450585 7.31484578,4.922185 C8.2443698,5.70762188 10.0438875,7.8539425 12.8028208,11.4459993 C13.1408693,11.8861293 13.0335172,12.4992928 12.5630432,12.8155382 C12.0925692,13.1317837 11.4371322,13.0313555 11.0990837,12.5912255 C8.44101017,9.13048544 6.68104531,7.03134029 5.90861111,6.37864246 C5.12699602,5.71818688 4.35258484,5.21384081 3.58716581,4.86252597 Z"
  }))), /*#__PURE__*/React.createElement("line", {
    x1: 2.64996823,
    y1: 7.24038217,
    x2: 16.4026,
    y2: 28.5,
    id: "extracted",
    stroke: "none",
    strokeLinecap: "square"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg611);
export default __webpack_public_path__ + "static/media/6-11.ca86928fdbaa7db59212d9bf3d64f6e8.svg";
export { ForwardRef as ReactComponent };